// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"App_backdrop__1CJn0","blockCenter":"App_blockCenter__Wl5u5"};